import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";

const ImageZoomPreviewer = ({ file, show, onClose }) => {
  const [imageUrl, setImageUrl] = useState(null);

  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
      <div className="d-flex gap-2 mb-3">
        <Button variant="outline-primary" onClick={() => zoomIn()}>
          Zoom In
        </Button>
        <Button variant="outline-primary" onClick={() => zoomOut()}>
          Zoom Out
        </Button>
        <Button variant="outline-secondary" onClick={() => resetTransform()}>
          Reset
        </Button>
      </div>
    );
  };

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [file]);

  if (!file || !imageUrl) return null;

  return (
    <Modal show={show} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TransformWrapper
          initialScale={1}
          initialPositionX={200}
          initialPositionY={100}
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              <Controls />
              <TransformComponent>
                <img src={imageUrl} alt="Zoomable" />
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageZoomPreviewer;
